import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import backgroundImage from '../../assets/Images/background.jpeg';
import '../../styles/MoldDesign.css';

const MoldDesign: React.FC = () => {
  const { t } = useTranslation();
  const services = t('moldDesignPage.services', { returnObjects: true }) as Array<any>;
  const process = t('moldDesignPage.process', { returnObjects: true }) as Array<any>;

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <motion.section 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="mold-design-hero"
      >
        <div className="absolute inset-0 bg-black/50 z-10" />
        <div className="absolute inset-0" style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }} />
        <div className="relative z-20 text-center text-white px-4">
          <motion.h1 
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="mold-design-hero-title"
          >
            {t('moldDesignPage.heroTitle')}
          </motion.h1>
          <motion.p 
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="mold-design-hero-subtitle"
          >
            {t('moldDesignPage.heroSubtitle')}
          </motion.p>
        </div>
      </motion.section>

      {/* Services Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="mold-design-services">
            {services.map((service, index) => (
              <motion.div
                key={index}
                initial={{ y: 20, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ delay: index * 0.2 }}
                className="mold-design-service-card"
              >
                <div className="mold-design-service-icon">{service.icon}</div>
                <h3 className="mold-design-service-title">{service.title}</h3>
                <p className="mold-design-service-desc">{service.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <h2 className="mold-design-process-title">{t('moldDesignPage.processTitle')}</h2>
          <div>
            {process.map((step, index) => (
              <motion.div
                key={index}
                initial={{ x: -20, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{ delay: index * 0.2 }}
                className="mold-design-process-step"
              >
                <div className="mold-design-step-number">
                  {step.step}
                </div>
                <div className="mold-design-step-content">
                  <h3 className="mold-design-step-title">{step.title}</h3>
                  <p className="mold-design-step-desc">{step.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="mold-design-cta-section">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="mold-design-cta-title">{t('moldDesignPage.ctaTitle')}</h2>
          <p className="mold-design-cta-desc">{t('moldDesignPage.ctaDesc')}</p>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="mold-design-cta-btn"
          >
            {t('moldDesignPage.ctaButton')}
          </motion.button>
        </div>
      </section>
    </div>
  );
};

export default MoldDesign; 